import InfoTooltip from "components/Popup/InfoTooltip";
import ToolTipPortal from "components/ToolTipPortal/ToolTipPortal";
import { IOutputListItem } from "Dashboard/scenes/Stock/domain/IOutputListItem";
import { stockService } from "Dashboard/scenes/Stock/services/stock.service";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { FormatDateShort } from "utils/dateUtils";
import { FormatNumberWithUnitOrNull } from "utils/numberUtils";
import { selectState } from "../inputSlice";

const initialState = {
  isOpen: false,
  top: 0,
  left: 0,
};

const BottomSection = () => {
  const [tooltip, setTooltip] = useState(initialState);
  const { selectedInputId } = useSelector(selectState);
  const [exemptions, setExemptions] = useState<IOutputListItem[]>([]);

  const close = () => {
    setTooltip(initialState);
  };

  useEffect(() => {
    const abortCtrl = new AbortController();

    const FetchData = async () => {
      try {
        if (selectedInputId !== -1) {
          let result = await stockService.getOutputs("Lager", {
            inputId: selectedInputId,
          }, { fetchMode: "replace" }, abortCtrl.signal);
          setExemptions(result.listItems);
        }
      } catch (err) {
        console.log(err);
      }
    };
    FetchData();
  }, [selectedInputId]);

  const whereOnInputPage = (outputListItem: IOutputListItem) => {
    let projectOfficial = outputListItem.project ? outputListItem.project.projectName : "";
    return outputListItem.partner
      ? outputListItem.partner.fullName
      : outputListItem.projectOverride
        ? outputListItem.projectOverride.projectName
        : projectOfficial;
  }

  const whereForReal = (outputListItem: IOutputListItem) => {
    let projectOfficial = outputListItem.project ? outputListItem.project.projectName : "";
    return outputListItem.partner
      ? outputListItem.partner.fullName
      : outputListItem.projectOverride
        ? `${projectOfficial} (na otpremnici: ${outputListItem.projectOverride.projectName})`
        : outputListItem.outputForEmployee
          ? `${projectOfficial} (za zaposlenog: ${outputListItem.outputForEmployee.name})`
          : projectOfficial;
  };

  return (
    <div className="lager-bottom-section">
      <div className="box-wrapper new-container">
        <div className="box-a">
          <div className="g-grid g-header">
            <div className="row">
              <div className="col lowercase center separator-line">
                <span>br. otpr-rač</span>
              </div>
              <div className="col lowercase separator-line">
                <span>gde je otišlo</span>
              </div>
              <div className="col lowercase center separator-line">
                <span>količina iz.</span>
              </div>
              <div className="col lowercase center separator-line">
                <span>cena po jed. m.</span>
              </div>
              <div className="col lowercase center separator-line">
                <span>cena izdatog</span>
              </div>
              <div className="col lowercase center separator-line">
                <span>datum izlaza</span>
              </div>
              <div className="col lowercase">
                <span>napomena</span>
                <select className="drop-menu">
                  <option></option>
                </select>
              </div>
            </div>
          </div>

          <div className="g-grid g-content">
            {exemptions.length > 0 &&
              exemptions.map((outputListItem, exemptionIndex) =>
                outputListItem.inputId === selectedInputId && (
                  <div
                    className="row"
                    key={outputListItem.outputId}
                  >
                    <div className="col">
                      <div className="bg-item center">
                        <InfoTooltip tooltip={`${outputListItem.billOfLandingId}`} element="span" classesProp=" light">
                          {outputListItem.billOfLandingId}
                        </InfoTooltip>
                      </div>
                    </div>
                    <div className="col uppercase strong">
                      <InfoTooltip tooltip={`${whereForReal(outputListItem)}`} classesProp={`bg-item${outputListItem.projectOverride ? " projectOverrideFirst" : ""}`}>
                        <span>{whereOnInputPage(outputListItem)}</span>
                      </InfoTooltip>
                    </div>
                    <div className="col strong">
                      <div className="bg-item right ">
                        <span className="danger">
                          {FormatNumberWithUnitOrNull(outputListItem.quantityAmount, outputListItem.unit.name)}
                        </span>
                      </div>
                    </div>
                    <div className="col">
                      <div className="bg-item right">
                        <span>
                          {FormatNumberWithUnitOrNull(outputListItem.pricePerUnit, 'rsd')}
                        </span>
                      </div>
                    </div>
                    <div className="col">
                      <div className="bg-item right">
                        <span>
                          {FormatNumberWithUnitOrNull(outputListItem.totalCost, 'rsd')}
                        </span>
                      </div>
                    </div>
                    <div className="col">
                      <div className="bg-item center">
                        <span className="light">
                          {FormatDateShort(outputListItem.date)}
                        </span>
                      </div>
                    </div>
                    <div className="col">
                      <div className="bg-item">
                        <span>{outputListItem.note}</span>
                      </div>
                    </div>
                  </div>
                )
              )}
          </div>
        </div>
        <div className="box-b">
          <div className="g-grid g-header">
            <div className="row">
              <div className="col">
                <span className="no-content">0</span>
                <select className="drop-menu">
                  <option></option>
                </select>
              </div>
            </div>
          </div>

          <div className="g-grid g-content" onScroll={() => close()}></div>
        </div>
      </div>
      <ToolTipPortal
        {...tooltip}
        onClose={close}
        text="Napomena"
        offset={{ top: -52, left: 10 }}
      >
        <textarea onKeyDown={() => { }}>Testni tooltip</textarea>
      </ToolTipPortal>
    </div>
  );
};

export default BottomSection;
